// pureParallax V.3.0

function pureParallax(customOptions) {
  const defaultOptions = {
    selector: "[data-depth]",
    axisSelector: "parallax-x",
    bgSelector: "parallax-bg",
    topSelector: "parallax-top",
    btmSelector: "parallax-btm",
    offsetHeader: true,
    headerId: "hd",
    minWidth: 64,
    outerSection: "section-container",
  }

  const options = { ...defaultOptions, ...customOptions }
  let screenWidth

  // Cache DOM elements and values
  const elements = document.querySelectorAll(options.selector)
  const header = document.getElementById(options.headerId)
  const windowHeight =
    window.innerHeight || document.documentElement.clientHeight
  const windowWidth = window.innerWidth || document.documentElement.clientWidth

  // Utility functions
  const isInViewport = (element, offset = 0) => {
    const rect = element.getBoundingClientRect()
    return (
      rect.bottom + offset > 0 &&
      rect.right > 0 &&
      rect.left < windowWidth &&
      rect.top - offset < windowHeight
    )
  }

  const EMsize = () => {
    return (
      windowWidth /
      parseFloat(getComputedStyle(document.querySelector("html")).fontSize)
    )
  }

  const elemToTop = (element) => element.getBoundingClientRect().top

  const findAncestor = (element, cls) => {
    while (
      (element = element.parentElement) &&
      !element.classList.contains(cls)
    );
    return element
  }

  // Main parallax function
  const applyParallax = () => {
    const hdHeight = header.offsetHeight
    const offsetDistTop = window.pageYOffset

    elements.forEach((element) => {
      if (isInViewport(element) && screenWidth >= options.minWidth) {
        const outerCont =
          findAncestor(element, options.outerSection) || element.parentElement
        const depth = parseFloat(element.getAttribute("data-depth"))
        const computedStyle = getComputedStyle(element)
        const borderOffset =
          parseFloat(computedStyle.borderTop) +
          parseFloat(computedStyle.borderBottom)

        let movement

        if (element.classList.contains(options.bgSelector)) {
          applyBgParallax(element, depth, hdHeight, offsetDistTop, borderOffset)
        } else {
          applyElementParallax(
            element,
            depth,
            hdHeight,
            offsetDistTop,
            outerCont,
            borderOffset
          )
        }
      } else {
        element.style.transform = "translate3d(0, 0, 0)"
      }
    })
  }

  const getImgRatio = (element) => {
    const computedStyle = window.getComputedStyle(element)
    const backgroundImage = computedStyle.backgroundImage.replace(
      /url\((['"])?(.*?)\1\)/gi,
      "$2"
    )
    const img = new Image()
    img.src = backgroundImage
    return img.width / img.height
  }

  const applyBgParallax = (
    element,
    depth,
    hdHeight,
    offsetDistTop,
    borderOffset
  ) => {
    const outerHeightBg = element.offsetHeight - borderOffset
    const isTopElem = elemToTop(element) + offsetDistTop - hdHeight <= 1

    if (isTopElem) {
      const movement = offsetDistTop * depth
      element.style.backgroundPosition = `50% ${Math.round(movement)}px`
    } else {
      // Movement
      const movement = -(elemToTop(element) * depth - hdHeight * depth)
      element.style.backgroundPosition = `50% ${Math.round(movement)}px`

      // Sizing
      const bgPadding = outerHeightBg + (windowHeight - outerHeightBg) * depth
      const computedWidth = getImgRatio(element) * bgPadding
      if (computedWidth > element.offsetWidth) {
        element.style.backgroundSize = `auto ${Math.round(bgPadding)}px`
      } else {
        element.style.backgroundSize = `${element.offsetWidth}px ${Math.round(
          element.offsetWidth / getImgRatio(element)
        )}px`
      }
    }
  }

  const applyElementParallax = (
    element,
    depth,
    hdHeight,
    offsetDistTop,
    outerCont
  ) => {
    let movement

    if (element.classList.contains(options.btmSelector)) {
      movement =
        (document.body.scrollHeight - windowHeight - window.scrollY) * depth
    } else {
      const isTopElem = elemToTop(outerCont) + offsetDistTop - hdHeight <= 1
      movement = isTopElem
        ? offsetDistTop * depth
        : -(elemToTop(outerCont) * depth - hdHeight * depth)
    }

    const translate3d = element.classList.contains(options.axisSelector)
      ? `translate3d(${Math.round(movement)}px, 0, 0)`
      : `translate3d(0, ${Math.round(movement)}px, 0)`

    element.style.transform = translate3d
  }

  // Event listeners
  const onLoadFunction = () => {
    screenWidth = EMsize()
    applyParallax()
    window.addEventListener("resize", onResizeFunction)
    window.addEventListener("scroll", applyParallax)
  }

  const onResizeFunction = () => {
    screenWidth = EMsize()
    applyParallax()
  }

  window.addEventListener("load", onLoadFunction)
}
